import type { Document } from './Document'
import Env from '@/infra/env'

/**
 * Triggers the download of a document's file.
 *
 * @param document
 * @param inline
 * @param token
 */
export function triggerDownload(
  document: Document,
  inline: boolean,
  token: string,
) {
  // The trick is to submit a POST form to the download
  // endpoint, that way the browser won't block it as a popup and we
  // can safely transfer the auth token.
  const url = `${Env.DOCUMENT_API_EXTERNAL}/v3/documents/${document.longId}/versions/${document.latestVersionId}/download/${document.file?.id}?preview=${inline}`
  const form = window.document.createElement('form')
  form.action = url
  form.method = 'post'
  form.target = '_blank'
  const input = window.document.createElement('input')
  input.type = 'hidden'
  input.name = '__authorization'
  input.value = `Bearer ${token}`
  form.appendChild(input)
  window.document.body.appendChild(form)
  form.submit()
  window.document.body.removeChild(form)
}
